import { DMN_PLANO } from "@src/domains";

export class Passo {
  constructor(options?: {
    ID: number;
    TXT_TITULO: string;
  }) {
    if (options) {
      this.ID = options.ID;
      this.TXT_TITULO = options.TXT_TITULO;
    }
  }

  ID: number;
  TXT_TITULO: string;
}

export const ListaPassos0001: Passo[] = [
  new Passo({
    ID: 0,
    TXT_TITULO: "Início",
  }),
  new Passo({
    ID: 1,
    TXT_TITULO: "Início",
  }),
  new Passo({
    ID: 2,
    TXT_TITULO: "Identificação",
  }),
  new Passo({
    ID: 3,
    TXT_TITULO: "Estado Civil",
  }),
  new Passo({
    ID: 4,
    TXT_TITULO: "Identificação Domiciliar",
  }),
  new Passo({
    ID: 5,
    TXT_TITULO: "Dados Bancários",
  }),
  new Passo({
    ID: 6,
    TXT_TITULO: "Beneficiários para fins de Pensão/Benefício por Morte",
  }),
  new Passo({
    ID: 7,
    TXT_TITULO: "Cadastramento do CPF dos Dependentes",
  }),
  new Passo({
    ID: 8,
    TXT_TITULO: "Pessoa Exposta Politicamente",
  }),
  // new Passo({
  //   ID: 9,
  //   TXT_TITULO: "Código de Ética e Conduta Faelce",
  // }),
  new Passo({
    ID: 10,
    TXT_TITULO: "Resumo e Confirmação",
  }),
];

export const ListaPassos0002: Passo[] = [
  new Passo({
    ID: 0,
    TXT_TITULO: "Início",
  }),
  new Passo({
    ID: 1,
    TXT_TITULO: "Início",
  }),
  new Passo({
    ID: 2,
    TXT_TITULO: "Identificação",
  }),
  new Passo({
    ID: 3,
    TXT_TITULO: "Estado Civil",
  }),
  new Passo({
    ID: 4,
    TXT_TITULO: "Identificação Domiciliar",
  }),
  new Passo({
    ID: 5,
    TXT_TITULO: "Dados Bancários",
  }),
  new Passo({
    ID: 6,
    TXT_TITULO: "Dependentes para fins de Benefício por Morte",
  }),
  new Passo({
    ID: 7,
    TXT_TITULO: "Cadastramento do CPF dos Dependentes",
  }),
  new Passo({
    ID: 8,
    TXT_TITULO: "Pessoa Exposta Politicamente",
  }),
  // new Passo({
  //   ID: 9,
  //   TXT_TITULO: "Código de Ética e Conduta Faelce",
  // }),
  new Passo({
    ID: 10,
    TXT_TITULO: "Resumo e Confirmação",
  }),
];

const ListasPassos = {
  [DMN_PLANO.BENEFICIO_DEFINIDO]: ListaPassos0001,
  [DMN_PLANO.CONTRIBUICAO_DEFINIDA]: ListaPassos0002
}

export function MontarListaPassosDisponiveis(ids: number[], cdPlano: string) {
  const ListaPassos = ListasPassos[cdPlano];

  if (ListaPassos === null || ListaPassos === undefined || ListaPassos.length === 0) {
    throw "Houve um erro ao carregar os seus passos disponíveis, favor contatr a Fundação.";
  }

  const passos = ListaPassos.filter(x => ids.includes(x.ID));
  return passos;
}

export enum IdPasso {
  SituacaoRecad = 0,
  Passo1 = 1,
  Passo2 = 2,
  Passo3 = 3,
  Passo4 = 4,
  Passo5 = 5,
  Passo6 = 6,
  Passo7 = 7,
  Passo8 = 8,
  Passo9 = 9,
  Passo10 = 10,
}
